import React, { useCallback } from "react";
import {
    CheckCircleOutlined,
    DeleteOutlined,
    EllipsisOutlined,
    MessageOutlined,
} from "@ant-design/icons";
import toastr from "toastr";
import {
    Avatar,
    Button,
    Dropdown,
    Popconfirm,
    Tooltip,
    Typography,
} from "antd";
import "./style.css";
import "dayjs/locale/vi";
import "./style.css";
import dayjs from "dayjs";
import relativeTime from "dayjs/plugin/relativeTime";
import API from "API";
import { useNavigate, useSearchParams } from "react-router-dom";
import { roleAvatar, roleList } from "const";
import { useAuth } from "AuthContext";
import ShowFiles from "components/general/ShowFiles";
import TextWithLatex from "components/general/TextWithLatex";
const { Text } = Typography;
dayjs.extend(relativeTime);
dayjs.locale("vi");
export const statusMapping = [
    {
        status: 0,
        color: "grey",
        text: "Đang chờ xử lý",
    },
    {
        status: 1,
        color: "blue",
        text: "Đang đợi giảng viên trả lời",
    },
    {
        status: 2,
        color: "blue",
        text: "Đang đợi sinh viên trả lời",
    },
    {
        status: 3,
        color: "green",
        text: "Đã đóng",
    },
];

function NewsFeed({ dataPost, getDataPost, setDataPost }) {
    const navigate = useNavigate();
    const { user } = useAuth();

    const [searchParams] = useSearchParams();
    const handleOnClickComment = () => {
        const paramsString = searchParams.toString();
        const url = `/student-posts/${dataPost.id}${
            paramsString ? `?${paramsString}` : ""
        }`;

        navigate(url);
    };
    const deleteNewsFeed = useCallback(async () => {
        try {
            await API.delete(`/student/posts/${dataPost?.id}/`);
            toastr.success("Xoá bài đăng thành công");
            getDataPost();
        } catch (error) {
            if (error?.response?.data?.error) {
                toastr.error(error?.response?.data?.error);
                return;
            }
        } finally {
            // setLoading(false)
        }
    }, [dataPost, getDataPost]);

    const makePostDone = useCallback(async () => {
        try {
            await API.post(`/student/make-post-done/`, {
                post_id: dataPost?.id,
            });
            setDataPost((dataPosts) => {
                dataPost.status = 3;
                const index = dataPosts.findIndex(
                    (item) => item.id === dataPost.id
                );
                dataPosts[index] = { ...dataPost };
                return [...dataPosts];
            });
            toastr.success("Cập nhật trạng thái thành công");
        } catch (error) {
            if (error?.response?.data?.error) {
                toastr.error(error?.response?.data?.error);
                return;
            }
        } finally {
        }
    }, [dataPost, setDataPost]);

    const items = [
        ...(dataPost?.status === 1 || dataPost?.status === 2
            ? [
                  {
                      label: (
                          <div>
                              <Popconfirm
                                  title="Bạn có chắc muốn đóng bài viết này?"
                                  onConfirm={(e) => {
                                      e.stopPropagation();
                                      makePostDone();
                                  }}
                                  okText="Đồng ý"
                                  cancelText="Hủy"
                              >
                                  <Button
                                      icon={<CheckCircleOutlined />}
                                      type="text"
                                      success
                                      style={{ color: "green" }}
                                      onClick={(e) => {
                                          e.stopPropagation();
                                      }}
                                  >
                                      Đóng bài viết
                                  </Button>
                              </Popconfirm>
                          </div>
                      ),
                      key: "0",
                  },
              ]
            : []),
        {
            label: (
                <div>
                    <Popconfirm
                        title="Bạn có chắc muốn xoá bài viết này?"
                        onConfirm={(e) => {
                            e.stopPropagation();
                            deleteNewsFeed();
                        }}
                        okText="Xoá"
                        cancelText="Hủy"
                    >
                        <Button
                            icon={<DeleteOutlined />}
                            type="text"
                            danger
                            onClick={(e) => {
                                e.stopPropagation();
                            }}
                        >
                            Xoá bài viết
                        </Button>
                    </Popconfirm>
                </div>
            ),
            key: "1",
        },
    ];
    return (
        <>
            <div style={{ marginTop: "10px" }}>
                <div className="newsfeed">
                    <div
                        style={{
                            display: "flex",
                            gap: "12px",
                            width: "100%",
                            backgroundColor: "#fff",
                        }}
                    >
                        <Tooltip title={roleList.find(item => item.role === dataPost.created_by_user.role).title}>
                            <Avatar src={roleAvatar.find(item => item.role === dataPost.created_by_user.role).avatar} />
                        </Tooltip>

                        <div style={{ flex: 1 }}>
                            <div
                                style={{
                                    display: "flex",
                                    justifyContent: "space-between",
                                    alignItems: "center",
                                }}
                            >
                                <div>
                                    <strong
                                        onClick={() => {
                                            navigate(
                                                `/users/${dataPost?.created_by_user?.id}`
                                            );
                                        }}
                                        style={{
                                            cursor: "pointer",
                                        }}
                                    >
                                        {dataPost?.created_by_user.last_name}{" "}
                                        {dataPost?.created_by_user.first_name}
                                    </strong>
                                    <Text
                                        type="secondary"
                                        style={{
                                            fontSize: 12,
                                            marginLeft: 8,
                                        }}
                                    >
                                        <Tooltip
                                            placement="topRight"
                                            title={`${dataPost.created_at.format(
                                                "DD/MM/YYYY HH:mm:ss"
                                            )}`}
                                        >
                                            {dayjs(
                                                dataPost?.created_at
                                            ).fromNow()}
                                        </Tooltip>
                                    </Text>
                                    <span
                                        style={{
                                            fontSize: 12,
                                            marginLeft: 5,
                                            display: "inline-block",
                                            backgroundColor:
                                                statusMapping?.find(
                                                    ({ status }) =>
                                                        status ===
                                                        dataPost?.status
                                                )?.color,
                                            color: "#fff",
                                            padding: "2px 8px",
                                            borderRadius: "99999px",
                                        }}
                                    >
                                        {
                                            statusMapping?.find(
                                                ({ status }) =>
                                                    status === dataPost?.status
                                            )?.text
                                        }
                                    </span>
                                </div>
                                {(user.role < 3 || dataPost.created_by === user.id) && <div>
                                    <Dropdown
                                        menu={{ items }}
                                        trigger={["click"]}
                                    >
                                        <Button
                                            type="text"
                                            icon={<EllipsisOutlined />}
                                            style={{
                                                fontSize: 20,
                                                color: "#999",
                                            }}
                                        />
                                    </Dropdown>
                                </div>}
                            </div>

                            <div
                                style={{
                                    marginTop: 4,
                                    wordBreak: "break-word",
                                }}
                            >
                                <TextWithLatex text={dataPost?.content}/>
                            </div>
                            <ShowFiles files={dataPost.images}/>
                        </div>
                    </div>
                    <div className="newsfeed-actions">
                        <div className="newsfeed-buttons">
                            <div
                                style={{
                                    flexBasis: "50%",
                                    textAlign: "center",
                                }}
                                onClick={handleOnClickComment}
                            >
                                <MessageOutlined /> Bình luận
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default NewsFeed;
